import { pathOr, propOr } from 'ramda'
import { createSelector } from 'reselect'

export const selectProducts = state => state.products

export const selectProductsList = createSelector(
  selectProducts,
  propOr([], 'list')
)

export const selectProductsListLoading = createSelector(
  selectProducts,
  propOr(false, 'isLoading')
)

export const selectShiftHistoryList = createSelector(
  selectProducts,
  propOr([], 'shiftHistoryList')
)

export const selectShiftHistoryListLoading = createSelector(
  selectProducts,
  propOr(false, 'isLoadingShiftHistory')
)

export const selectChangesHistoryList = createSelector(
  selectProducts,
  propOr([], 'changesHistoryList')
)

export const selectChangesHistoryListLoading = createSelector(
  selectProducts,
  propOr(false, 'isLoadingChangesHistory')
)

export const selectCurrentProduct = createSelector(
  selectProducts,
  propOr({}, 'currentProduct')
)

export const selectCurrentProductLoading = createSelector(
  selectProducts,
  propOr(false, 'isLoadingCurrentProduct')
)

export const selectCurrentProductFiles = createSelector(
  selectProducts,
  pathOr([], ['currentProduct', 'files'])
)

export const selectCurrentProductIconLargeUrl = createSelector(
  selectProducts,
  pathOr([], ['currentProduct', 'iconLargeUrl'])
)

export const selectCurrentProductIconSmallUrl = createSelector(
  selectProducts,
  pathOr([], ['currentProduct', 'iconSmallUrl'])
)

export const selectProductsListPagination = createSelector(
  selectProducts,
  propOr(
    {
      totalPages: 1,
      perPage: 20,
      itemsCount: 0
    },
    'pagination'
  )
)

export const selectShiftHistoryListPagination = createSelector(
  selectProducts,
  propOr(
    {
      totalPages: 1,
      perPage: 20,
      itemsCount: 0
    },
    'shiftHistoryListPagination'
  )
)

export const selectChangesHistoryListPagination = createSelector(
  selectProducts,
  propOr(
    {
      totalPages: 1,
      perPage: 20,
      itemsCount: 0
    },
    'changesHistoryListPagination'
  )
)
